import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=3eae8536&"
import script from "./SearchHeader.controller.js?vue&type=script&lang=js&"
export * from "./SearchHeader.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SearchHeader.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "16e03894"
  
)

export default component.exports